// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1053":"fc5c20ce","8154":"22f1f4fb","8829":"22f1f4fb"}[chunkId] + ".chunk.css";
};